import React from 'react';

export default  ({defaultPlace,latitude,longitude}) => {
    const googleAPIKey = 'AIzaSyBuC3QTIveXi31zmAWqqsX2hFRURhintxI'
    let coordinates = (!latitude || !longitude) ? defaultPlace : `${latitude},${longitude}`;
    return(
        <iframe
            src={`https://www.google.com/maps/embed/v1/place?key=${googleAPIKey}&q=${coordinates}` }
            allowFullScreen={true}
        >
        </iframe>
    );
}
